import React from 'react'
import { Route, Routes } from "react-router-dom";
import Dashboard from '../components/Admin/Dashboard';

/**
 * 
 * @export
 * @function RouterDashboard
 * @description Router for dashboard routes 
 */
function RouterDashboard(props) {
  return (
    <Routes>
      <Route path='/' element={<Dashboard />}/>
    </Routes>
  )
}

export default RouterDashboard